export default __webpack_public_path__ + "static/media/Forest-Layer-1.13c5f7d9.png";